import { FormControl, Validators } from '@angular/forms';
import { EoCustomControlConfig, EoDropdownConfig, EoFormPanelConfig, EoInputConfig } from 'ngx-eo-web-components';

export const exampleFormConfig = new EoFormPanelConfig({
  header: 'Στοιχεία Επικοινωνίας',
  headerStyleClass: 'p-panel-title',
  name: 'contactFormConfig',
  styleClass: 'container',

  config: [
    new EoInputConfig({
      name: 'name',
      label: 'Όνομα',
      placeholder: 'Παρακαλώ συμπληρώστε Όνομα',
      styleClass: 'col-12',
      control: new FormControl('', [Validators.required]),
      errors: { required: 'Υποχρεωτικό πεδίο' }
    }),
    new EoInputConfig({
      name: 'surname',
      label: 'Μολις επιλεξεις τιμη στο dropdown θα διαγραφει το πεδιο',
      placeholder: 'Παρακαλώ συμπληρώστε Επώνυμο',
      styleClass: 'col-12',
      control: new FormControl('', [Validators.required]),
      errors: { required: 'Υποχρεωτικό πεδίο' }
    }),
    new EoInputConfig({
      name: 'email',
      label: 'Email',
      placeholder: 'Παρακαλώ συμπληρώστε Email',
      styleClass: 'col-12',
      type: 'email',
      control: new FormControl('', [Validators.required, Validators.pattern(/^[^\s@]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/)]),
      errors: {
        required: 'Υποχρεωτικό Πεδίο',
        email: 'Μη έγκυρο email'
      }
    }),
    new EoDropdownConfig<any>({
      name: 'region',
      label: 'Περιοχή',
      placeholder: 'Επιλέξτε περιοχή',
      styleClass: 'col-12',
      options: [
        { label: 'Europe', value: 'europe' },
        { label: 'America', value: 'america' },
      ],
      optionLabel: 'label',
      optionValue: 'value',
      control: new FormControl(null, [Validators.required]),
      appendTo: 'body',
      errors: { required: 'Υποχρεωτικό πεδίο' },
    }),
    new EoDropdownConfig<any>({
      name: 'phone',
      label: 'Κωδικός χώρας',
      placeholder: 'Επιλέξτε κωδικό χώρας',
      styleClass: 'col-12',
      options: [],
      optionLabel: 'label',
      optionValue: 'value',
      control: new FormControl(null, [Validators.required]),
      appendTo: 'body',
      errors: { required: 'Υποχρεωτικό πεδίο' },
    }),
  ]
});

export const examplePageFormConfig: EoFormPanelConfig[] = [exampleFormConfig];
